import {
  getRemainingViewsText,
  getResourceRemainingViews,
} from "@app/resources/utils/resource-view-limit";
import { lessonAtom } from "@core/grades/atoms";
import type { Resource } from "@core/shared/types";
import { cn } from "@design-system/utils";
import { Eye } from "lucide-react";

type ResourceRemainingViewsProps = {
  resource: Resource;
  className?: string;
};

/**
 * Subtle hint showing how many views are left for a view-limited resource
 */
export function ResourceRemainingViews({
  resource,
  className,
}: ResourceRemainingViewsProps) {
  // re-render when the lesson is refreshed after tracking a view
  lessonAtom.useValue();

  if (resource.isLocked) return null;

  const remaining = getResourceRemainingViews(resource);

  if (remaining === null) return null;

  const isWarning = remaining <= 1;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 text-xs font-medium",
        isWarning
          ? "text-amber-600 dark:text-amber-400"
          : "text-slate-500 dark:text-slate-400",
        className,
      )}
    >
      <Eye className="h-3 w-3 shrink-0" />
      <span>{getRemainingViewsText(remaining)}</span>
    </span>
  );
}
